import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseAvatarGroupElement, toAvatarGroupProps } from '../common';
var CollaboratorGroupElement = function CollaboratorGroupElement(props) {
  var context = useFlexibleUiContext();
  var data = context ? toAvatarGroupProps(context.collaboratorGroup, false) : undefined;
  return data ? /*#__PURE__*/React.createElement(BaseAvatarGroupElement, _extends({}, data, props, {
    name: ElementName.CollaboratorGroup
  })) : null;
};
export default CollaboratorGroupElement;